import {
  IMeasureFilterFieldsFragment,
  IMeasureFilterInput,
  InputMaybe,
} from '../../../apollo/graphqlSchema';

export const prepareMeasureFilterInput = (
  measureFilter: IMeasureFilterFieldsFragment | null,
): InputMaybe<IMeasureFilterInput> => {
  if (measureFilter) {
    return {
      relOp: measureFilter.relOp.key,
      values: measureFilter.values,
    };
  }

  return null;
};
